<template>
  <div class="news-cont-box" ref="box">
    <p class="top-tip">此为临时链接，仅用于预览</p>
    <p class="title" v-if="
      pageType == 1 &&
      (type == 3 || $route.query.type !== 'audio') &&
      (type == 3 || $route.query.type !== 'video')
    " ref="titleStyle">
      {{ title }}
    </p>
    <ul class="time" v-if="
      pageType == 1 &&
      (type == 3 || $route.query.type !== 'audio') &&
      (type == 3 || $route.query.type !== 'video')
    ">
      <li v-if="source">来源:{{ source }}</li>
      <li>{{ createTime }}</li>
    </ul>
    <div v-if="$route.query.type == 'manuscripts'" class="Introduction" @click="imgPath" ref="Introduction"
      v-html="fullWord"></div>
    <div v-if="$route.query.type == 'atlas'">
      <div class="news-content atlas-content" v-if="type == 3">
        <el-carousel height="550PX" :autoplay="false">
          <el-carousel-item v-for="(item, index) in cont.info" :key="index">
            <p class="atlas-img-box">
              <img class="atlas-img" :src="item.url" alt="" />
            </p>
            <p class="atlas-describe">
              <span class="describe-index"><i>{{ index + 1 }}</i>/{{ cont.info.length }}</span>
              <span class="describe-cont">{{ item.describe }}</span>
            </p>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="phone-box atlas-phone-box" v-else>
        <div class="phone-box-content atlas-content">
          <el-carousel height="340PX" :autoplay="false" ref="carousel">
            <el-carousel-item v-for="(item, index) in cont.info" :key="index">
              <div class="atlas-phone-img-box">
                <img class="atlas-phone-img" :src="item.url" alt="" />
                <span class="describe-index"><i>{{ index + 1 }}</i>/{{ cont.info.length }}</span>
              </div>
              <p class="atlas-describe">
                <span class="describe-cont">{{ item.describe }}</span>
              </p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div v-if="$route.query.type == 'video'">
      <div class="news-content atlas-content" v-if="type == 3">
        <div class="video-content">
          <vue-aliplayer-v2 class="preview-video" :sourceUrl="cont.lowPath[0] || cont.path[0] || cont.sourceLink"
            ref="VueAliplayerV2" />
        </div>
      </div>
      <div class="phone-box" v-else>
        <div class="video-phone-content">
          <div class="phone-video-content">
            <vue-aliplayer-v2 class="preview-video" :sourceUrl="cont.lowPath[0] || cont.path[0] || cont.sourceLink"
              ref="VueAliplayerV2" />
          </div>
          <h2 class="phone-title">{{ cont.title }}</h2>
          <div class="user-info">
            <ul class="info-phone-auter">
              <li v-if="cont.source" style="margin-right: 10PX;">
                来源: {{ cont.source }}
              </li>
              <li>{{ initTime(cont.createTime) }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.query.type == 'audio'" class="pc-audio-content">
      <div :class="this.audio.playing ? 'play-audio-content' : 'audio-content'" v-if="type == 3">
        <img v-if="this.audio.playing" class="gif-img" :src="require('@/assets/img/preview/audio-back.gif')" alt="" />
        <audio ref="audio" @pause="onPause" @play="onPlay" @timeupdate="onTimeupdate" @loadedmetadata="onLoadedmetadata"
          :src="cont.lowPath[0] || cont.path[0] || cont.sourceLink" controls="controls" style="display: none;"></audio>
        <div class="control-box">
          <!-- 进度条 -->
          <div class="audio-progress">
            <el-slider v-model="sliderTime" :format-tooltip="formatProcessToolTip" @change="changeCurrentTime"
              class="slider"></el-slider>
          </div>
          <!-- 音频播放控件 -->
          <div class="audio-control">
            <div class="control-left">
              <div class="audio-btn">
                <el-button v-if="!this.audio.playing" type="text" @click="play"><img
                    :src="require('@/assets/img/playerimg/palying.png')" alt="" /></el-button>
                <el-button v-else type="text" @click="pause"><img :src="require('@/assets/img/playerimg/pause.png')"
                    alt="" /></el-button>
              </div>
              <p class="audio-time">
                <span>{{ realFormatSecond(this.audio.currentTime) }}</span>/
                <span>{{ audioInfo.time }}</span>
              </p>
            </div>
            <div class="audio-sound">
              <el-slider class="sound-slider" style="width: 100PX; cursor: pointer;" v-model="soundValue"
                @change="getChange"></el-slider>
              <div id="player_sound_btn_player" volume="50" ismute="false" @click="showSound"
                @mouseenter="showMouse = true" @mouseleave="showMouse = false">
                <img v-if="!sound && !showMouse" id="player_sound_yes_player" src="@/assets/img/playerimg/sound.png" />
                <img v-if="sound && !showMouse" id="player_sound_no_player" src="@/assets/img/playerimg/sound-no.png" />
                <img v-if="!sound && showMouse" id="player_sound_yes_player"
                  src="@/assets/img/playerimg/sound-hover.png" />
                <img v-if="sound && showMouse" id="player_sound_yes_player"
                  src="@/assets/img/playerimg/sound-no-hover.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="phone-box" v-else>
        <div class="audio-phone-content">
          <div class="phone-audio-content">
            <audio ref="audio" @pause="onPause" @play="onPlay" @timeupdate="onTimeupdate"
              @loadedmetadata="onLoadedmetadata" :src="cont.lowPath[0] || cont.path[0] || cont.sourceLink"
              controls="controls" style="display: none;"></audio>
            <div class="show-audio">
              <div v-if="cont.coverimgPathList.length > 0" class="have-cover">
                <img :src="cont.coverimgPathList[0]" alt="" :class="this.audio.playing ? 'adimat-box' : ''" />
              </div>
              <div v-else class="have-cover">
                <img :src="require('@/assets/img/preview/defult.png')" alt=""
                  :class="this.audio.playing ? 'adimat-box' : ''" />
              </div>
            </div>
            <div class="audio-phone-control">
              <span class="audio-phone-time">{{
                  realFormatSecond(this.audio.currentTime)
              }}</span>
              <div class="audio-phone-progress">
                <el-slider v-model="sliderTime" :format-tooltip="formatProcessToolTip" @change="changeCurrentTime"
                  class="slider"></el-slider>
              </div>
              <span class="audio-phone-time">{{ audioInfo.time }}</span>
            </div>
            <div class="audio-phone-button">
              <img @click="changeTime(-1)" :src="require('@/assets/img/preview/快退.png')" alt="" />
              <img style="width: 56PX; height: 56PX;" v-if="!this.audio.playing" @click="play"
                :src="require('@/assets/img/palying.png')" alt="" />
              <img style="width: 56PX; height: 56PX;" v-else @click="pause" :src="require('@/assets/img/puseing.png')"
                alt="" />
              <img @click="changeTime(1)" :src="require('@/assets/img/preview/快进.png')" alt="" />
            </div>
          </div>
          <h2 class="phone-title">{{ cont.title }}</h2>
          <div class="user-info">
            <ul class="info-phone-auter">
              <li v-if="cont.source" style="margin-right: 10PX;">
                来源: {{ cont.source }}
              </li>
              <li>{{ initTime(cont.createTime) }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.query.type == 'audio' || $route.query.type == 'video'" class="audio-describe-cont">
      <span class="audio-describe-cont">{{ cont.news }}</span>
    </div>
    <ul :class="$route.query.type == 'atlas' && type == 3 ? 'atlas-info' : ''"
      style="color: #a8b1bb; line-height: 28PX; font-size: 14PX; margin: 6PX 0;">
      <li v-if="cont.editor">
        <i v-if="type !== 3" style="margin-right: 5PX;">|</i>编辑:
        {{ cont.editor }}
      </li>
      <li v-if="cont.author">
        <i v-if="type !== 3" style="margin-right: 5PX;">|</i>责任编辑:
        {{ cont.author }}
      </li>
    </ul>
    <div :class="$route.query.type == 'atlas' && type == 3 ? 'atlas-wmk' : ''" v-if="wmkUse"
      style="text-align: left; padding-bottom: 16PX; padding-top: 5PX;" :style="{
        fontSize: waterMark.wmkWordSize + 'PX',
        opacity: waterMark.wmkWordTrans / 100,
      }">
      {{ waterMark.wmkWordContent || 12233 }}
    </div>
  </div>
</template>

<script>
import { Toast } from "vant"
import * as sctipts from "../service/share"
import share from "../utils/share"
import VueAliplayerV2 from "@/components/playerbox/ckPlayer"
// import {getModules} from "../api/getModules";
export default {
  data() {
    return {
      cont: "",
      pageType: 1,
      title: "",
      author: "",
      source: "",
      createTime: "",
      fullWord: "",
      webcommentList: [],
      type: "0",
      versionUrl: "",
      appName: "",
      appIcon: "",
      shareIcon: require("../assets/img/shareLogo.png"),
      editor: "",
      linkList: [],
      newList: [],
      showFullContent: false,
      appScheme: "",
      viewTotal: "",
      timer: null,
      downLink: "",
      // 水印
      waterMark: {},
      // 是否开启水印 wmkUse 0 否 1 是
      wmkUse: 0,
      modules: "newsDetail", // 模块类型

      showMouse: false,
      followBtn: false,
      newSoundValue: 75,
      soundValue: 75,
      sound: false,
      sliderTime: 0,
      audioDetail: {},
      audioInfo: {
        time: 0,
      },
      progressing_audio: 0,
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
      },
    }
  },
  // created () {
  //   window.addEventListener("beforeunload", this.beforeUnloadHandler, false)
  // },
  components: {
    VueAliplayerV2,
  },
  mounted() {
    if (this.equipmentType() == "iOS") {
      this.type = 0
    } else if (this.equipmentType() == "Android") {
      this.type = 1
    } else {
      this.type = 3
    }
    if (this.$route.query.id) {
      let data = {
        id: this.$route.query.id,
        type: this.$route.query.type,
      }
      sctipts
        .getPreview(data)
        .then(({ data }) => {
          if (data.status == 0) {
            if (data.data) {
              this.cont = data.data
              this.title = data.data.title || ""
              this.source = data.data.source || ""
              this.author = data.data.author || ""
              this.editor = data.data.editor || ""
              this.createTime = sctipts.initTime(data.data.createTime, 1)
              this.fullWord = data.data.fullWord || ""
              this.viewTotal = data.data.viewTotal
              document.title = this.title
              this.linkList = data.data.linkList || []
              this.newList = data.data.newList
              this.wmkUse = data.data.wmsUse
              let obj = {
                title: data.data.title,
                desc: data.data.news,
                link: location.href,
                img: data.data.lowPath,
              }
              let url =
                process.env.NODE_ENV === "production"
                  ? window.location.href
                  : process.env.VUE_APP_URL + this.$route.fullPath
              share.getJSSDK(url.split("#")[0], obj)

              if (this.wmkUse == 1) {
                // 获取文章水印列表
                let obj = {
                  pageIndex: 1,
                  pageSize: 99999,
                  wmkRange: 1,
                }
                sctipts.getWater(obj).then((res) => {
                  if (res.data.status === 0 && res.data.data.list) {
                    var waterData = res.data.data.list.filter((val) => {
                      return val.wmkId == data.data.wmkId
                    })
                    this.waterMark = waterData[0]
                  }
                })
              }
            }
          } else {
            console.log(data.desc)
          }
        })
        .catch((res) => {
          console.log("连接服务器错误")
        })
      // sctipts
      //   .getComment(this.$route.query.id)
      //   .then(({
      //     data
      //   }) => {
      //     if (data.status == 0) {
      //       if (data.data) {
      //         this.webcommentList = data.data;
      //       }
      //     } else {
      //       console.log(data.desc);
      //     }
      //   })
      //   .catch((res) => {
      //     console.log("连接服务器错误");
      //   });
      // sctipts
      //   .getAppUrl({
      //     type: this.type,
      //     bundleID: this.$route.query.bundleID
      //   })
      //   .then(({
      //     data
      //   }) => {
      //     if (data.status == 0) {
      //       if (data.data) {
      //         this.versionUrl = data.data.versionUrl;
      //         this.appName = data.data.applicationName;
      //         this.appIcon = data.data.applicationHeadPath;
      //         this.appScheme = data.data.applicationUrlScheme
      //       }
      //     } else {
      //       console.log(data.desc);
      //     }
      //   });
    } else {
      console.log("未获取id")
    }
    window.audioPause = this.audioPause
    window.videoPause = this.clearVideo
    this.$nextTick(() => {
      if (
        this.$route.query.type !== "audio" &&
        this.$route.query.type !== "video"
      ) {
        this.$refs.titleStyle.style.marginTop = 10 + "PX"
      }
      if (this.type !== 3 && this.$route.query.type == "atlas") {
        this.slideBanner()
      }
    })
  },
  methods: {
    // 图集轮播图
    // 轮播手滑切换
    slideBanner() {
      let that = this
      //选中item的盒子
      var box = document.querySelector(".el-carousel__container")
      //手指起点X坐标
      var startPoint = 0
      //手指滑动重点X坐标
      var stopPoint = 0
      //重置坐标
      var resetPoint = function () {
        startPoint = 0
        stopPoint = 0
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX
      })
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX
      })
      //当手指抬起的时候，判断图片滚动离左右的距离
      box.addEventListener("touchend", function () {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint()
          return
        }
        if (startPoint - stopPoint > 0) {
          resetPoint()
          that.$refs.carousel.next()
          return
        }
        if (startPoint - stopPoint < 0) {
          resetPoint()
          that.$refs.carousel.prev()
          return
        }
      })
    },

    clearVideo() {
      this.$refs.Introduction.querySelectorAll("video").forEach((element) => {
        element.pause()
      })
    },
    equipmentType() {
      let u = navigator.userAgent
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1 //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isAndroid) {
        return "Android"
      } else if (isiOS) {
        return "iOS"
      } else {
        return "noMobileDevices"
      }
    },
    initTime(time, type) {
      return sctipts.initTime(time, type)
    },
    getDateDiff(time) {
      return sctipts.getDateDiff(time)
    },
    imgPath(event) {
      if (event.target.nodeName == "IMG") {
        // 获取触发事件对象的属性
        let allPathArr = []
        let index = ""
        for (
          let i = 0;
          i < this.$refs.Introduction.querySelectorAll("img").length;
          i++
        ) {
          allPathArr.push(
            this.$refs.Introduction.querySelectorAll("img")[i].src
          )
        }
        allPathArr.forEach((val, ind) => {
          if (val == event.target.src) {
            index = ind
          }
        })

        let objData = {
          thisPath: event.target.src,
          allPath: allPathArr,
          indexOf: index,
        }
        if (this.equipmentType() == "iOS") {
          window.webkit.messageHandlers.showImage.postMessage(objData)
        } else if (this.equipmentType() == "Android") {
          Android.openImage(event.target.src, allPathArr, index)
        }
      }
    },
    returnImgPath(row) {
      if (row.coverimgStyleId == 0) {
        return require("@/assets/img/default.png")
      } else {
        if (row.coverimgLowPathList) {
          if (row.coverimgLowPathList[0]) {
            return row.coverimgLowPathList[0]
          } else if (row.coverimgPathList) {
            if (row.coverimgPathList[0]) {
              return row.coverimgPathList[0]
            }
          }
        } else if (row.coverimgPathList) {
          if (row.coverimgPathList[0]) {
            return row.coverimgPathList[0]
          }
        } else {
          return ""
        }
      }
    },
    audioPause() {
      this.$refs.Introduction.querySelectorAll("audio").forEach((element) => {
        element.pause()
      })
    },
    getDate(time) {
      let Time
      if (time) {
        Time = new Date(time)
      } else {
        Time = new Date()
      }
      let m = Time.getMonth() + 1
      let d = Time.getDate()
      m = m > 9 ? m : "0" + m
      d = d > 9 ? d : "0" + d
      return `${m}-${d}`
    },
    initTime(time) {
      let Time
      if (time) {
        Time = new Date(time)
      } else {
        Time = new Date()
      }
      let y = Time.getFullYear()
      let m = Time.getMonth() + 1
      let d = Time.getDate()
      let h = Time.getHours()
      let mm = Time.getMinutes()
      let s = Time.getSeconds()
      // ${y}-${m}-${d} ${h}:${mm}:${s}
      return `${y}-${m}-${d} ${h}:${mm}:${s}`
    },
    // 音频时间
    realFormatSecond(second) {
      var secondType = typeof second
      if (secondType === "number" || secondType === "string") {
        second = parseInt(second)
        var hours = Math.floor(second / 3600)
        second = second - hours * 3600
        var mimute = Math.floor(second / 60)
        second = second - mimute * 60
        //   return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
        return ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2)
      } else {
        return "00:00"
      }
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play()
    },

    // 播放音频
    play() {
      this.$refs.audio.play()
      this.timer = setInterval(() => {
        this.progressing_audio =
          (this.progressing_audio / 100 + 0.1 / this.audio.maxTime) * 100
        this.second = this.second + 0.1
        if (this.progressing_audio >= 100) {
          clearInterval(this.timer)
          this.progressing_audio = 0
          this.second = 0
        }
      }, 100)
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause()
      clearInterval(this.timer)
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false
    },
    // 进度条toolTip
    formatProcessToolTip(index) {
      index = parseInt((this.audio.maxTime / 100) * index)
      return "进度条: " + this.realFormatSecond(index)
    },
    // 播放跳转
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(
        (index / 100) * this.audio.maxTime
      )
    },
    changeTime(type) {
      if (this.audio.currentTime + 15 * type <= 0) {
        this.$refs.audio.currentTime = 0
      } else if (this.audio.currentTime + 15 * type > this.audio.maxTime) {
        this.$refs.audio.currentTime = this.audio.maxTime
      } else {
        this.$refs.audio.currentTime = this.audio.currentTime + 15 * type
      }
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.audio.currentTime = res.target.currentTime
      this.sliderTime = (this.audio.currentTime / this.audio.maxTime) * 100
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audioInfo.time = this.realFormatSecond(parseInt(res.target.duration))
      this.audio.maxTime = parseInt(res.target.duration)
    },
    showSound() {
      //声音
      this.sound = !this.sound
      if (this.sound) {
        this.soundValue = 0
        this.$refs.audio.volume = this.soundValue / 100
      } else {
        this.soundValue = this.newSoundValue
        this.$refs.audio.volume = this.soundValue / 100
      }
    },
    getChange() {
      this.sound = false
      this.newSoundValue = this.soundValue
      this.$refs.audio.volume = this.newSoundValue / 100
    },
  },
  filters: {
    // 使用组件过滤器来动态改变按钮的显示
    transPlayPause(value) {
      return value ? "el-icon-video-pause" : "el-icon-video-play"
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
@import "./preview.css";
.atlas-content>>>.el-carousel__indicators--horizontal {
  display: none;
}

.atlas-content>>>.el-carousel__arrow {
  width: 40PX;
  height: 40PX;
  font-size: 24PX;
  top: 40%;
}

.audio-btn .el-button {
  padding: 0PX;
  font-size: unset;
}

.audio-progress>>>.el-slider__runway {
  margin: 10PX 0;
  height: 10PX;
}

.audio-progress>>>.el-slider__button-wrapper {
  width: 12PX;
  height: 12PX;
  top: -2PX;
}

.audio-progress>>>.el-slider__button {
  width: 12PX;
  height: 12PX;
  border: 1PX solid #409eff;
  display: block;
}

.sound-slider>>>.el-slider__bar {
  background-color: #3a83ff !important;
  height: 10PX !important;
  margin-left: 0PX;
}

.audio-progress>>>.el-slider__bar {
  background-color: #3a83ff !important;
  height: 10PX;
}

/* .audio-progress >>> .el-slider__button-wrapper{
  display: none; 
} */
.audio-phone-content .audio-phone-progress>>>.el-slider__button-wrapper {
  width: 10PX;
  height: 10PX;
  top: -2PX;
}

.audio-phone-progress>>>.el-slider__button {
  width: 10PX;
  height: 10PX;
  /* border: 1PX solid #409EFF; */
  margin-top: 0PX;
  display: block;
}

.sound-slider>>>.el-slider__button {
  width: 10PX;
  height: 10PX;
  border: 1PX solid #409eff;
  margin-top: -11PX;
}

.audio-sound>>>.el-slider__button {
  width: 10PX;
  height: 10PX;
  border: 1PX solid #409eff;
}

.audio-sound>>>.el-slider__runway {
  height: 10PX;
  margin: 0;
}

.audio-sound>>>.el-slider__button-wrapper {
  width: 100PX;
  height: 10PX;
  top: 0PX;
}

.audio-phone-content .user-info {
  padding: 0PX;
}

.top-tip {
  text-align: center;
  line-height: 36PX;
  background: #eff5fe;
  color: #666666;
  font-size: 14PX;
  font-family: SourceHan;
  font-weight: 500;
  margin: -20PX -15PX 20PX -15PX;
}

.news-cont-box {
  max-width: 1200PX;
  /* height: 100%; */
  margin: 0 auto;
  padding: 15PX 15PX 0;
  padding: calc(15PX + constant(safe-area-inset-top)) calc(15PX + constant(safe-area-inset-right)) 0 calc(15PX + constant(safe-area-inset-left));
  padding: calc(15PX + env(safe-area-inset-top)) calc(15PX + env(safe-area-inset-right)) 0 calc(15PX + env(safe-area-inset-left));
  background-color: #fafafa;
  box-sizing: border-box;
  /* overflow: hidden; */
  position: relative;
}

.title {
  max-height: 50PX;
  font-weight: bold;
  margin-top: 20PX;
  color: #333;
  font-weight: 700;
  font-size: 18PX;
  font-family: SourceHan;
  line-height: 1.3;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.time {
  display: flex;
  font-size: 12PX;
  align-items: center;
  margin-top: 10PX;
}

.time>li {
  margin-right: 10PX;
  color: #999;
  font-size: 14PX;
  height: 14PX;
  line-height: 16PX;
  font-family: SourceHan;
}

.Introduction-hidden {
  height: 300PX;
  overflow: hidden;
  position: relative;
}

.Introduction-hidden-icon {
  content: "";
  width: 100%;
  height: 200PX;
  background-image: linear-gradient(transparent, #fff);
  z-index: 9999;
  margin-top: -200PX;
  position: relative;
}

.Introduction-hidden-icon img {
  position: absolute;
  bottom: 20PX;
  left: 0;
  right: 0;
  margin: auto;
}

.open-app {
  width: 100%;
  display: block;
  border: none;
  height: 44PX;
  background-color: #be1928;
  color: #fff;
  font-size: 14PX;
  border-radius: 5PX;
  margin-bottom: 22PX;
  outline: none;
  text-align: center;
  line-height: 44PX;
  text-decoration: none;
}

.open-app-border {
  width: 100%;
  display: block;
  height: 44PX;
  border: 1PX solid #be1928;
  color: #be1928 !important;
  font-size: 14PX;
  border-radius: 5PX;
  margin-bottom: 22PX;
  outline: none;
  text-align: center;
  line-height: 44PX;
  text-decoration: none;
}

.all-com-title {
  font-size: 16PX;
  color: #333;
  font-weight: bold;
  margin-bottom: 17PX;
}

.host-list {
  width: 100%;
  margin-bottom: 25PX;
}

.host-list>li {
  overflow: hidden;
  margin: 15PX 0;
  font-size: 16PX;
}

.host-list>li>img {
  width: 35PX;
  height: 35PX;
  border-radius: 50%;
  background-color: #fff;
  float: left;
  overflow: hidden;
}

.host-list>li>ul {
  width: calc(100% - 47PX);
  float: right;
  overflow: hidden;
}

.host-list>li>ul>li:nth-child(1) {
  height: 20PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.host-list>li>ul>li:nth-child(1)>p {
  font-size: 14PX;
  color: #518dfa;
  max-width: 70%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.host-list>li>ul>li:nth-child(1)>span {
  font-size: 12PX;
  color: #999;
}

.host-list>li>ul>li:nth-child(2) {
  font-size: 15PX;
  color: #333;
  margin-top: 4PX;
}

.news-links {
  overflow: hidden;
  margin-bottom: 60PX;
}

.news-links>li {
  height: 86PX;
  margin-bottom: 23PX;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.news-links>li>div {
  width: calc(100% - 130PX);
  height: 86PX;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news-links>li>div>p {
  font-size: 16PX;
  color: #333;
  height: 66PX;
  overflow: hidden;
  line-height: 1.5;
}

.news-links>li>div>span {
  font-size: 12PX;
  color: #8a8a8a;
  height: 20PX;
  line-height: 20PX;
}

.news-links>li>img {
  width: 114PX;
  height: 86PX;
  background-color: #999;
  border-radius: 3PX;
}

.news-newList-item-left {
  height: 40PX;
  width: calc(100% - 100PX);
  display: flex;
  align-items: center;
}

.news-newList-item-left>img {
  border-radius: 3PX;
  object-fit: cover;
}

.news-newList-item-left-text {
  width: calc(100% - 50PX);
  height: 40PX;
  margin-left: 10PX;
}

.news-newList-item-left-text>p {
  color: #333333;
  font-size: 14PX;
  height: 20PX;
  line-height: 20PX;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.news-newList-item-left-text>span {
  color: #8a8a8a;
  font-size: 12PX;
  height: 20PX;
  line-height: 20PX;
  display: block;
}
</style>
<style>
i {
  font-style: normal;
}

/* @import '../components/setFont/font.less'; */
/* .app-view .down-app-btn {
  width: 72PX;
  height: 32PX !important;
  border-radius: 5PX !important;
  font-size: 14PX !important;
  color: #fff !important;
  padding: 0PX !important;
}

.app-view .down-app-btn-bottom {
  width: 58PX;
  height: 24PX !important;
  border-radius: 5PX !important;
} */

.news-newList-box {
  width: 100%;
  height: 56PX;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99999;
  border-top: 1PX solid #eee;
  background-color: #fff;
}

.news-newList .van-swipe-item {
  width: 100%;
  height: 56PX;
  line-height: 56PX;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7PX 13PX;
  box-sizing: border-box;
}

.news-newList .van-swipe__indicators {
  bottom: 7PX;
}

.Introduction {
  margin-bottom: 16PX;
  margin-top: 22PX;
  overflow-y: auto;
  font-size: 18PX;
  line-height: 1.667;
  font-family: SourceHan;
  text-align: justify;
  color: #212228;
  font-weight: 300;
}

.Introduction img {
  width: 100%;
  display: block;
  margin: 5PX auto;
  max-width: 100%;
  object-fit: scale-down;
}

.Introduction video {
  width: 100%;
  max-height: 440PX;
  display: block;
  margin: 0 auto;
  max-width: 100%;
  background-color: #000;
}
</style>
